import Box from '@mui/material/Box';
import { InvoiceCategoryFilter } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';

import { OverflowAwareText } from '~components/Order/ordersDispatchStyledComponents';
import { Order } from '~hooks/useOrders/models';
import { Summary } from '~pages/Dispatch/components/OrderSummary';

interface StatsSlotProps {
  order: Order;
  invoiceCategory: InvoiceCategoryFilter;
}

export function StatsSlot({ order, invoiceCategory }: StatsSlotProps) {
  const { orderSummary } = order;

  const loadsCount = orderSummary?.loadsCount ?? 0;
  const approvedLoadsCount = orderSummary?.approvedLoadsCount ?? 0;

  const approvedInvoiceCount =
    invoiceCategory === InvoiceCategoryFilter.PAYABLES
      ? (orderSummary?.approvedPayables ?? 0)
      : (orderSummary?.approvedReceivables ?? 0);

  const totalInvoiceCount =
    invoiceCategory === InvoiceCategoryFilter.PAYABLES
      ? (orderSummary?.totalPayables ?? 0)
      : (orderSummary?.totalReceivables ?? 0);

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Summary
          count={approvedInvoiceCount}
          total={totalInvoiceCount}
          description={t(
            'approvals.driver_pay.order_card_stats.invoices_approved.summary_text',
            {
              approved: approvedInvoiceCount,
              total: totalInvoiceCount,
            },
          )}
          descriptionSx={{ mb: 0.5, fontWeight: 500, fontSize: '14px' }}
        />

        <OverflowAwareText
          sx={(theme) => ({ fontSize: '12px', color: theme.brandV2.colors.treadGray3 })}
        >
          {t('approvals.driver_pay.order_card_stats.invoices_approved.description')}
        </OverflowAwareText>
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Summary
          count={approvedLoadsCount}
          total={loadsCount}
          description={t(
            'approvals.driver_pay.order_card_stats.loads_approved.summary_text',
            {
              approved: approvedLoadsCount,
              total: loadsCount,
            },
          )}
          descriptionSx={{ mb: 0.5, fontWeight: 500, fontSize: '14px' }}
        />

        <OverflowAwareText
          sx={(theme) => ({ fontSize: '12px', color: theme.brandV2.colors.treadGray3 })}
        >
          {t('approvals.driver_pay.order_card_stats.loads_approved.description')}
        </OverflowAwareText>
      </Box>
    </>
  );
}
